declare var itemDetailsPathBase: string;
declare var clientCode: string;
declare var storeCode: string;
declare var displayItemImages: boolean;
declare var isViewOnly: boolean;

export class ShippingUI {
    private tableBody = $("#assets-table");

    public updateTable(assets: any[]): void {
        this.tableBody.empty();
        this.hideMissingItems(); // Hide missing items when updating table
        if (!assets || assets.length === 0) {
            this.renderEmptyRow("No assets found for this barcode.");
            return;
        }
        assets.forEach((asset: any) => this.upsertRow(asset, asset.shopify_url));
    }

    public upsertRow(asset: any, shopifyUrl?: string): void {
        // Remove empty state if present (handle both 12 and 13 column layouts)
        this.tableBody.find("td[colspan='12'], td[colspan='13']").closest("tr").remove();

        const existing = this.tableBody.find("tr").filter((i, el) => {
            const row = $(el);
            const rowAssetId = row.attr("data-asset-id");
            const rowEpc = row.attr("data-epc");
            const rowSerial = row.attr("data-serial-number");

            const assetId = asset.id ? String(asset.id) : "";
            const assetEpc = asset.epc || "";
            const assetSerial = asset.serial_number || "";

            // Check all three: asset ID, EPC, and serial number
            // All must match to consider it the same row
            const assetIdMatch = (!rowAssetId && !assetId) || (rowAssetId && assetId && rowAssetId === assetId);
            const epcMatch = (!rowEpc && !assetEpc) || (rowEpc && assetEpc && rowEpc === assetEpc);
            const serialMatch = (!rowSerial && !assetSerial) || (rowSerial && assetSerial && rowSerial === assetSerial);

            return assetIdMatch && epcMatch && serialMatch;
        });

        const row = this.createRow(asset, shopifyUrl);

        if (existing.length > 0) {
            existing.replaceWith(row);
        } else {
            this.tableBody.append(row);
        }
    }

    private createRow(asset: any, shopifyUrl?: string): JQuery<HTMLElement> {
        const row = $("<tr>")
            .addClass("center-content")
            .attr("data-epc", asset.epc || "")
            .attr("data-serial-number", asset.serial_number || "")
            .attr("data-asset-id", asset.id || "")
            .attr("data-shopify-url", shopifyUrl || "")
            .attr("data-shipped", asset.shipped ? "true" : "false")
            .attr("data-ref-number", asset.ref_number || "")
            .attr("data-is-so-multi", asset.is_so_multi ? "true" : "false");

        row.append($("<td>").html(asset.shipped ? '<i class="fa fa-check text-success"></i>' : '<i class="fa fa-close text-danger"></i>'));

        // Item# with link
        const itemNumberCell = $("<td>");
        if (asset.item_number && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
            const itemGroupUrl = `/${clientCode}/${storeCode}/item_group/${encodeURIComponent(asset.item_number)}`;
            itemNumberCell.html(`<a href="${itemGroupUrl}" target="_blank">${asset.item_number}</a>`);
        } else {
            itemNumberCell.text(asset.item_number || "");
        }
        row.append(itemNumberCell);

        row.append($("<td>").attr("style", "text-align: left !important;").text(asset.item_details || ""));

        // Serial Number with link
        const serialNumberCell = $("<td>");
        const serialNumberText = asset.serial_number || "";
        if (asset.epc && typeof itemDetailsPathBase !== 'undefined') {
            const itemDetailsUrl = `${itemDetailsPathBase}/${encodeURIComponent(asset.epc)}`;
            serialNumberCell.html(`<a href="${itemDetailsUrl}" target="_blank">${serialNumberText}</a>`);
        } else {
            serialNumberCell.text(serialNumberText);
        }
        row.append(serialNumberCell);

        row.append($("<td>").text(asset.type || ""));

        // REF# with link (sales order or transfer order based on type)
        const refNumberCell = $("<td>");
        const refNumber = asset.ref_number || "-";
        if (refNumber !== "-" && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
            if (asset.type === 'so' && asset.sales_order_id) {
                const salesOrderUrl = `/${clientCode}/${storeCode}/sales_orders/transactions/${asset.sales_order_id}`;
                refNumberCell.html(`<a href="${salesOrderUrl}" target="_blank">${refNumber}</a>`);
            } else if (asset.type === 'to' && asset.eos_transfer_id) {
                const transferUrl = `/${clientCode}/${storeCode}/transactions/distribution_transfer_details/${asset.eos_transfer_id}?integration_type=d365`;
                refNumberCell.html(`<a href="${transferUrl}" target="_blank">${refNumber}</a>`);
            } else {
                refNumberCell.text(refNumber);
            }
        } else {
            refNumberCell.text(refNumber);
        }
        row.append(refNumberCell);

        row.append($("<td>").text(asset.source || ""));
        row.append($("<td>").text("1"));
        row.append($("<td>").attr("style", "text-align: left !important;").text(asset.picked_into || ""));
        row.append($("<td>").text(asset.picked_by || ""));
        row.append($("<td>").text(asset.picked_at || ""));

        // Add image column if enabled
        if (typeof displayItemImages !== 'undefined' && displayItemImages) {
            const imageCell = $("<td>")
                .addClass("image-cell")
                .css({
                    "padding": "8px",
                    "vertical-align": "middle",
                    "text-align": "center"
                });
            const thumbUrl = asset.item_image_url || "";
            const originalUrl = asset.item_image_original_url || thumbUrl;
            const placeholderImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
            const hasRealImage = originalUrl && originalUrl !== placeholderImage;

            const img = $("<img>")
                .attr("src", thumbUrl)
                .attr("alt", asset.item_details || "Item Image")
                .css({
                    "max-width": "50px",
                    "max-height": "50px",
                    "width": "auto",
                    "height": "auto",
                    "object-fit": "contain",
                    "border-radius": "5px",
                    "display": "block",
                    "margin": "0 auto"
                })
                .on("error", function() {
                    $(this).hide();
                    $(this).attr("src", "");
                    $(this).attr("alt", "");
                    $(this).removeAttr("title");
                    $(this).removeAttr("data-original");
                    $(this).removeAttr("data-alt");
                });

            if (hasRealImage) {
                img.addClass("modal-image-trigger")
                   .css("cursor", "pointer")
                   .attr("title", "Click to view full size")
                   .attr("data-original", originalUrl)
                   .attr("data-alt", asset.item_details || asset.item_number || "");
            } else {
                img.css("opacity", "0.5");
            }

            imageCell.append(img);
            row.append(imageCell);
        }

        const actionsCell = $("<td>").addClass("sn-icons");

        const shopifyLink = $("<a>")
            .attr("href", "#")
            .addClass("fa fa-external-link-square fa-2x upgrade-icon")
            .attr("title", "Open in Shopify")
            .attr("data-toggle", "tooltip");

        const markShippedLink = $("<a>")
            .attr("href", "#")
            .addClass("fa fa-truck fa-2x run-icon")
            .attr("title", "Mark Shipped")
            .attr("data-toggle", "tooltip");

        // Disable Shopify link for transfer orders (type === 'to')
        const isTransferOrder = asset.type === 'to';
        if (isTransferOrder) {
            shopifyLink.addClass("disabled not-allowed").css("opacity", "0.5");
        } else {
            // Shopify link always works, even for shipped assets (but not for transfer orders)
            shopifyLink.on("click", (e: JQuery.ClickEvent) => {
                e.preventDefault();
                window.dispatchEvent(new CustomEvent('shopify-click', { detail: { row, shopifyUrl } }));
            });
        }

        // Disable Mark Shipped button if asset is already shipped
        if (asset.shipped) {
            markShippedLink.addClass("disabled not-allowed").css("opacity", "0.5");
        } else {
            // Mark as Ship button: disabled in view-only mode, enabled otherwise
            if (isViewOnly) {
                markShippedLink.addClass("disabled not-allowed").css("opacity", "0.5");
            } else {
                markShippedLink.on("click", (e: JQuery.ClickEvent) => {
                    e.preventDefault();
                    window.dispatchEvent(new CustomEvent('ship-confirm-click', { detail: { row, asset } }));
                });
            }
        }

        actionsCell.append(shopifyLink);
        actionsCell.append(markShippedLink);
        row.append(actionsCell);

        if (typeof ($ as any).fn.tooltip !== 'undefined') {
            shopifyLink.tooltip();
            markShippedLink.tooltip();
        }

        return row;
    }

    private renderEmptyRow(message: string): void {
        const colspan = (typeof displayItemImages !== 'undefined' && displayItemImages) ? 13 : 12;
        const emptyRow = $("<tr>").addClass("center-content");
        const emptyCell = $("<td>")
            .attr("colspan", colspan.toString())
            .addClass("text-center text-muted")
            .css("padding", "40px")
            .html(`
                <i class="fa fa-search fa-3x" style="margin-bottom: 10px; opacity: 0.3;"></i>
                <br/>
                <span style="font-size: 16px;">${message}</span>
            `);
        emptyRow.append(emptyCell);
        this.tableBody.append(emptyRow);
    }

    public updateMissingItems(missingItems: any[]): void {
        const missingItemsSection = $("#shipping-missing-items-section");
        const missingItemsTbody = $("#shipping-missing-items-tbody");

        if (!missingItems || missingItems.length === 0) {
            missingItemsSection.hide();
            return;
        }

        missingItemsSection.show();
        missingItemsTbody.empty();

        missingItems.forEach((item: any) => {
            const row = $("<tr>").addClass("center-content");

            // Item# with link
            const itemNumberCell = $("<td>");
            if (item.item_number && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
                const itemGroupUrl = `/${clientCode}/${storeCode}/item_group/${encodeURIComponent(item.item_number)}`;
                itemNumberCell.html(`<a href="${itemGroupUrl}" target="_blank">${item.item_number}</a>`);
            } else {
                itemNumberCell.text(item.item_number || '');
            }
            row.append(itemNumberCell);

            row.append($("<td>").text(item.upc || '-'));
            row.append($("<td>").attr("style", "text-align: left !important").text(item.item_details || ''));

            // REF# with link
            const refNumberCell = $("<td>");
            if (item.ref_number && item.ref_number !== '-' && item.sales_order_id && typeof clientCode !== 'undefined' && typeof storeCode !== 'undefined') {
                const salesOrderUrl = `/${clientCode}/${storeCode}/sales_orders/transactions/${item.sales_order_id}`;
                refNumberCell.html(`<a href="${salesOrderUrl}" target="_blank">${item.ref_number}</a>`);
            } else {
                refNumberCell.text(item.ref_number || '-');
            }
            row.append(refNumberCell);

            row.append($("<td>").text(item.source || ''));
            row.append($("<td>").text(item.expected || 0));
            row.append($("<td>").attr("style", "text-align: left !important").css("text-align", "left !important").text(item.reason || ''));

            // Add image column if enabled
            if (typeof displayItemImages !== 'undefined' && displayItemImages) {
                const imageCell = $("<td>")
                    .addClass("image-cell")
                    .css({
                        "padding": "8px",
                        "vertical-align": "middle",
                        "text-align": "center"
                    });
                const thumbUrl = item.item_image_url || "";
                const originalUrl = item.item_image_original_url || thumbUrl;
                const placeholderImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
                const hasRealImage = originalUrl && originalUrl !== placeholderImage;

                const img = $("<img>")
                    .attr("src", thumbUrl)
                    .attr("alt", item.item_details || "Item Image")
                    .css({
                        "max-width": "50px",
                        "max-height": "50px",
                        "width": "auto",
                        "height": "auto",
                        "object-fit": "contain",
                        "border-radius": "5px",
                        "display": "block",
                        "margin": "0 auto"
                    })
                    .on("error", function() {
                        $(this).hide();
                        $(this).attr("src", "");
                        $(this).attr("alt", "");
                        $(this).removeAttr("title");
                        $(this).removeAttr("data-original");
                        $(this).removeAttr("data-alt");
                    });

                if (hasRealImage) {
                    img.addClass("modal-image-trigger")
                       .css("cursor", "pointer")
                       .attr("title", "Click to view full size")
                       .attr("data-original", originalUrl)
                       .attr("data-alt", item.item_details || item.item_number || "");
                } else {
                    img.css("opacity", "0.5");
                }

                imageCell.append(img);
                row.append(imageCell);
            }

            missingItemsTbody.append(row);
        });
    }

    public hideMissingItems(): void {
        $("#shipping-missing-items-section").hide();
    }
}

